<template>
  <ion-page>
    <ion-content class="consent-settings-content">
      <StickyPageHeader :title="copy.settingsTitle" @back="closeModal" />

      <div class="consent-settings-page">
        <div class="consent-category">
          <div class="consent-category__header">
            <span class="consent-category__title">{{ copy.necessaryTitle }}</span>
            <span class="consent-category__badge">Immer aktiv</span>
          </div>
          <p class="consent-category__text">{{ copy.necessaryDescription }}</p>
        </div>

        <p class="consent-info-note">
          Ollaa Partner setzt keine optionalen Analyse- oder Marketing-Cookies ein.
        </p>

        <button type="button" class="consent-privacy-link" @click="openPrivacy">
          {{ copy.privacyLink }}
        </button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { IonPage, IonContent, modalController } from '@ionic/vue';
import StickyPageHeader from '@/components/ui/StickyPageHeader.vue';
import { CONSENT_COPY } from '@/constants/consent';
import { openLegalDocument } from '@/utils/openLegalDocument';

const copy = CONSENT_COPY;

const closeModal = () => modalController.dismiss();

const openPrivacy = () => openLegalDocument('datenschutz');
</script>

<style lang="scss" scoped>
@use '@/styles/consent.scss' as consent;

.consent-settings-content {
  --background: #fff;
}

.consent-settings-page {
  padding: 8px 20px 40px;
}

.consent-category {
  margin-bottom: 24px;
}

.consent-category__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.consent-category__title {
  font-size: 18px;
  font-weight: 400;
  color: #1a1a1a;
}

.consent-category__badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f4f4f4;
  font-size: 12px;
  color: #666;
}

.consent-category__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #666;
}

.consent-info-note {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.45;
  color: #1a1a1a;
}

.consent-privacy-link {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  color: consent.$consent-accent;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}
</style>
